<template>
  <div class="m-page">
    <template v-if="isType==1">
      <div>
        <div class="m-box">
          <div class="m-ico-box">
            <van-icon class="m-ico" name="passed" />
            <div class="m-line"></div>
          </div>
          <div class="m-ico-box">
            <div class="m-line"></div>
            <van-icon class="m-circle" name="circle" />
            <div class="m-line m-line-active"></div>
          </div>
          <div class="m-ico-box">
            <div class="m-line m-line-active"></div>
            <van-icon class="m-circle-ice" name="circle" />
            <!--<div class="m-line"></div>-->
          </div>
        </div>
        <div class="m-text">
          <p class="m-width"><span class="m-child">申请退款</span></p>
          <div class="m-width">
            <div class="m-sku">
              <div>
                审核中
              </div>
              <span>请等待管理员审核</span>
            </div>
          </div>
          <p class="m-width"><span class="m-last m-right-20">退款结果</span></p>
        </div>
      </div>
    </template>
    <template v-if="isType==2">
      <div>
        <div class="m-box">
          <div class="m-ico-box">
            <van-icon class="m-ico" name="passed" />
            <div class="m-line"></div>
          </div>
          <div class="m-ico-box">
            <div class="m-line"></div>
            <van-icon class="m-ico" name="passed" />
            <div class="m-line"></div>
          </div>
          <div class="m-ico-box">
            <div class="m-line"></div>
            <van-icon class="m-circle" name="circle" />
            <!--<div class="m-line"></div>-->
          </div>
        </div>
        <div class="m-text">
          <p class="m-width"><span class="m-child">管理员审核</span></p>
          <p class="m-width"><span class="m-last m-right-28">退款结果</span></p>
          <div class="m-width">
            <div class="m-last-sku">
              <div>
                退款成功
              </div>
              <span>{{obj.refundAmount}}元</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="isType==3">
      <div>
        <div class="m-box">
          <div class="m-ico-box">
            <van-icon class="m-ico" name="passed" />
            <div class="m-line"></div>
          </div>
          <div class="m-ico-box">
            <div class="m-line"></div>
            <van-icon class="m-ico" name="passed" />
            <div class="m-line"></div>
          </div>
          <div class="m-ico-box">
            <div class="m-line"></div>
            <van-icon class="m-circle" name="circle" />
            <!--<div class="m-line"></div>-->
          </div>
        </div>
        <div class="m-text">
          <p class="m-width"><span class="m-child">管理员审核</span></p>
          <p class="m-width"><span class="m-last m-right-21">退款结果</span></p>
          <div class="m-width">
            <div class="m-last-sku">
              <div style="color: red">
                退款失败
              </div>
              <span>{{obj.refundAmount}}元</span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

  export default {
    props:{
      isType:{
        type:Number,
        default:1
      },
      obj:{
        type:Object,
        default: () => {}
      }
    },
    components: {},
    data () {
      return {
        active:2,
      }
    },
    created () {

    },
    methods: {},
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
 .m-page{
    .m-box{
      display: flex;
      width: 80%;
      margin: 0 auto;
      .m-ico-box{
        width: calc(100%/3);
        display: flex;
        align-items: center;
        .m-line{
          flex: 1;
          height: 1Px;
          background: #ffffff;
        }
        .m-line-active{
          background: #6F9BFB!important;
        }
        .m-ico{
          color: #FFFFFF;
          font-size: 15px;
        }
        .m-circle{
          background: #ffffff;
          color: #ffffff;
          border-radius: 50%;
          font-size: 12px;
        }
        .m-circle-ice{
          color: #6F9BFB;
          font-size: 15px;
        }
      }
    }
   .m-text{
     display: flex;
     width: 80%;
     margin: 10px auto 0 auto;
     .m-width{
       width: calc(100%/3) ;
       position: relative;
       .m-child{
         position: absolute;
         font-size: 12px;
         color: #77A1FB;
         left: -20px;
       }
       .m-sku{
         position: absolute;
         right: 20px;
         >div{
           width: 62px;
           padding: 4px 0;
           text-align: center;
           background: #ffffff;
           border-radius: 14px;
           color: #2B6CF9;
           font-size: 14px;
           font-weight: bold;
         }
         >span{
           color: #ffffff;
           font-size: 13px;
           position: absolute;
           white-space: nowrap;
           left: -20px;
           margin-top: 6px;
         }
       }
       .m-last-sku{
         position: absolute;
         right: -24px;
         >div{
           width: 62px;
           padding: 4px 0;
           text-align: center;
           background: #ffffff;
           border-radius: 14px;
           color: #2B6CF9;
           font-size: 14px;
           font-weight: bold;
         }
         >span{
           width: 62px;
           text-align: center;
           display: inline-block;
           color: #ffffff;
           font-size: 13px;
           position: absolute;
           white-space: nowrap;
           margin-top: 6px;
         }
       }
       .m-last{
         position: absolute;
         font-size: 12px;
         color: #77A1FB;
       }
       .m-right-20{
         right: -20px;
       }
       .m-right-28{
         right: 28px;
       }
       .m-right-21{
         right: 21px;
       }
     }

   }
 }
</style>

